import React, {Component} from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Tabs } from 'antd';
import ModificationTab from '../components/SetParameters.ModificationTab';
import DigestionTab from '../components/SetParameters.DigestionTab';
import IsotopeLabelsTab from '../components/SetParameters.IsotopeTab';
import IsobaricLabelTab from '../components/SetParameters.IsobaricTab';
// temp removed for version 2.0.0
// import AdvancedSettingsTab from '../components/SetParameters.AdvancedSettingTab';
import SettingsTab from '../components/SetParameters.SettingsTab';

// import data
import {
  fixedModifications, 
  variableModifications,
  digestEnzymeList, 
  digestModeList,
  isotopeLabels,
  isobaricLabelList,
  isobaricLabelTable,
  instrumentResolutionOptions
} from '../assets/constants/parameters';

const TabPane = Tabs.TabPane;

class SetParameters extends Component{
  callback(key){
    //console.log(key);
  }
  render(){
    //console.log(this.props);
    return(
      <div className="step-outter-wrapper">
        <div className="step-inner-wrapper">

          <div className="step-title-style">
            <h3>Set Parameters</h3>
          </div>

          <div className="step-content-style">
            
            {
              this.props.parameters.workflowDefault === 'taxonomy analysis'
              &&
              <div css={css`
                font-weight: 600;
                text-align: center;
              `}>Parameter adjustment is not needed for Taxonomy Analysis Workflow</div>
            }

            <Tabs onChange={this.callback} 
              type="card" 
              style={{minHeight: 600, marginLeft: 10, marginRight: 10,}}>
              
              {
                (this.props.parameters.workflowDefault === 'closed search' 
                || this.props.parameters.workflowDefault === 'open search')
                &&
                <TabPane tab="Modifications" key="1">
                  <ModificationTab 
                    fixedModifications={fixedModifications}
                    variableModifications={variableModifications}
                    parameters={this.props.parameters}
                    updateParameters={this.props.updateParameters} />
                </TabPane>
              }

              {
                (this.props.parameters.workflowDefault === 'closed search' 
                || this.props.parameters.workflowDefault === 'open search')
                &&
                <TabPane tab="Digestion" key="2">
                  <DigestionTab 
                    digestModeList={digestModeList}
                    digestEnzymeList={digestEnzymeList}
                    updateParameters={this.props.updateParameters}
                    parameters={this.props.parameters} />
                </TabPane>
              }
              
              {
                this.props.parameters.workflowDefault === 'closed search'
                &&
                <TabPane tab="Isotope labels" key="3">
                  <IsotopeLabelsTab 
                    isotopeLabels={isotopeLabels}
                    parameters={this.props.parameters}
                    updateParameters={this.props.updateParameters} />
                </TabPane>
              }

              {
                this.props.parameters.workflowDefault === 'closed search'
                &&
                <TabPane tab="Isobaric labels" key="4">
                  <IsobaricLabelTab 
                    isobaricLabelList={isobaricLabelList}
                    isobaricLabelTable={isobaricLabelTable}
                    updateParameters={this.props.updateParameters}
                    parameters={this.props.parameters} />
                </TabPane>
              }

              {
                (this.props.parameters.workflowDefault === 'closed search' 
                || this.props.parameters.workflowDefault === 'open search')
                &&
                <TabPane tab="Settings" key="5">
                  <SettingsTab 
                    instrumentResolutionOptions={instrumentResolutionOptions}
                    parameters={this.props.parameters}
                    updateParameters={this.props.updateParameters} />
                </TabPane>
              }              
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default SetParameters;

// Advanced setting tab is temporarily removed for v2.0.0
// the tab component is kept for future reference
// data input:
// taxaNodeOptions,
// taxonomyAnalysisOptions,
// ignoreTaxaBelowParentOptions,
// taxaOptions,
{/* <TabPane tab="Advanced settings" key="6">
  <AdvancedSettingsTab 
    taxaNodeOptions={taxaNodeOptions}
    taxonomyAnalysisOptions={taxonomyAnalysisOptions}
    ignoreTaxaBelowParentOptions={ignoreTaxaBelowParentOptions}
    instrumentResolutionOptions={instrumentResolutionOptions}
    taxaOptions={taxaOptions}
    parameters={this.props.parameters}
    updateParameters={this.props.updateParameters} />
</TabPane> */}
// 
